module.exports = __webpack_public_path__ + "static/media/search.aea329b1.svg";